import React from 'react';
import { Line } from 'common/line';
import { Button, ButtonSize, ButtonStyle, ButtonType } from 'common/button';
import { classnames } from 'helpers/utils';
import styles from './reset-password-steps.module.scss';

type ResetPasswordStep2Props = {
  email: string;
  notifGoBack: () => void;
  backToLogin: () => void;
};

const ResetPasswordStep2: React.FC<ResetPasswordStep2Props> = ({
  email,
  notifGoBack,
  backToLogin,
}) => (
  <div className={styles.containerStep2}>
    <div className={styles.containerTitle}>
      <div className={classnames(styles.titleText, 'text__title1__gray800')}>
        Check your email!
      </div>
      <div className={classnames('text__body__regular__medium__gray700')}>
        We&apos;ve sent you instructions to reset your password to{' '}
        <strong>{email}</strong>.
      </div>
    </div>

    <Button
      className={classnames(styles.backButton)}
      onClick={backToLogin}
      buttonSize={ButtonSize.Medium}
      buttonType={ButtonType.Submit}
    >
      Back to Login
    </Button>
    <Line />
    <div className={classnames(styles.footerCheck)}>
      <p className="text__body__regular__small__gray700">
        Didn’t receive the email? Check your spam folder or make sure your email
        address is correct. If needed,{' '}
        <Button
          buttonSize={ButtonSize.Small}
          buttonStyle={ButtonStyle.PrimaryGhostLink}
          onClick={notifGoBack}
        >
          update it here
        </Button>
      </p>
    </div>
  </div>
);

export { ResetPasswordStep2 };
